"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RXDB_VERSION = void 0;
/**
 * This file is replaced in the 'npm run build:version' script.
 */
var RXDB_VERSION = '14.17.1';
exports.RXDB_VERSION = RXDB_VERSION;
//# sourceMappingURL=utils-rxdb-version.js.map